import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';

import { useBroadcast } from './hooks/useBroadcast';
import { pictureParamsData } from './data';

import { Picture } from './components/Picture/Picture';
import Advt from './components/Advt/Advt';
import { SmallAdvt } from './components/SmallAdvt/SmallAdvt';

import styles from './App.module.css';

import defaultBackground from './assets/images/bg.webp';
import posterDefault from './assets/images/advtBgPoster.webp';
import bgDefaultVideo from './assets/video/advtBg.webm';
import { MadeIactivePro } from './components/MadeIactivePro/MadeIactivePro';

function App() {
  const { allMessages, currentState } = useBroadcast();

  const messagesByTag = useMemo(() => {
    const grouped = {};
    allMessages.forEach((msg) => {
      if (!grouped[msg.titrTag]) grouped[msg.titrTag] = [];
      grouped[msg.titrTag].push(msg);
    });
    return grouped;
  }, [allMessages]);

  return (
    <div className={styles.appWrapper}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className={styles.motionBlock}
            key={`${currentState}-advt`}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <Advt />
          </motion.div>
        )}

        {currentState === 'S2' && (
          <motion.div
            className={styles.motionBlock}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            key={`${currentState}-pictures`}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            {pictureParamsData.map((pic) => {
              const currentMessagesByTag = messagesByTag[pic.tag];
              if (!currentMessagesByTag) {
                return null;
              }
              return (
                <Picture
                  key={pic.tag}
                  currentMessagesByTag={currentMessagesByTag}
                  left={`${pic.left}rem`}
                  top={`${pic.top}rem`}
                  width={`${pic.width}rem`}
                  height={`${pic.height}rem`}
                  borderRadius={pic.borderRadius}
                />
              );
            })}

            <SmallAdvt />

            <img
              src={defaultBackground}
              alt="bg"
              className={styles.bg}
              loading="lazy"
              decoding="sync"
            />

            <MadeIactivePro left />
          </motion.div>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.bgVideo}
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>
    </div>
  );
}

export default App;
